module.exports = __webpack_public_path__ + "media/images/shared/popup_about/step-1-92af847122bc85f7172c5e9d7491eb1d.jpg";